import React from "react";
import "../index.css";
import brightonio from "../media/brightonio.png";
import hand from "../media/mano.png";
import ielts from "../media/ielts.jpg";
import aptis from "../media/aptis.jpg";
import toefl from "../media/toefl.jpg";
import oopt from "../media/oopt.jpg";
import seccion from "../media/img-01.png";
import CardCursos from "components/CardCursos";
import profesoresData from "../data/profesores.json";
import ProfesorCard from "components/ProfesorCard";
import WhyCard from "components/Index/WhyCard";
import Seo from "components/Seo/Seo";
import CardEstadisticas from "components/Index/CardEstadisticas";
import TestimonialsMarquee from "components/Testimonios/TestimonialsMarquee";
import Carrusel from "components/Carrusel/Carrusel";
import cursosData from "../data/cursos.json";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const dataEstadisticas = [
  {
    icon: "fa-solid fa-user-graduate",
    numero: "+ 1000",
    texto: "Estudiantes certificados en OOPT",
    bgColor: "bg-blue-100",
    textColor: "text-blue-800",
  },
  {
    icon: "fa-solid fa-award",
    numero: "+ 500",
    texto: "Estudiantes certificados en IELTS",
    bgColor: "bg-rose-400",
    textColor: "text-rose-800",
  },
  {
    icon: "fa-solid fa-trophy",
    numero: "+ 2700",
    texto: "Estudiantes Certificados en APTIS",
    bgColor: "bg-lime-400",
    textColor: "text-lime-600",
  },
  {
    icon: "fa-solid fa-chalkboard-user",
    numero: "+ 25",
    texto: "Profesores Certificados",
    bgColor: "bg-yellow-400",
    textColor: "text-yellow-700",
  },
];
const Exams = [
  { name: "IELTS", img: ielts, link: "/certificaciones/ielts" },
  { name: "TOEFL", img: toefl, link: "/certificaciones/toefl" },
  { name: "APTIS", img: aptis, link: "/certificaciones/aptis" },
  { name: "OOPT", img: oopt, link: "/certificaciones/oopt" },
];
const itemsCarrusel = cursosData.map((curso, index) => (
  <CardCursos
    key={index}
    curso={curso.titulo}
    descripcion={curso.descripcion}
    url={curso.url}
    img={curso.img}
    // Puedes pasar otras props para personalizar WhyCard
  />
));
const itemsProfes = profesoresData.map((profes, index) => (
  <ProfesorCard key={index} profesor={profes} />
));
const ExamnCard = ({ link, img, exam }) => {
  return (
    <div className=" w-0 flex-grow-[1] transition-all duration-300 ease-in-out hover:flex-grow-[4] overflow-hidden rounded-lg rounded-tl-none">
      <Link to={link}>
        <img
          src={img}
          width={1080}
          loading="lazy"
          alt={`Examen de certificacion ${exam}`}
          className="object-cover h-full w-full hover:scale-110 transition duration-300 ease-in-out"
        />
      </Link>
    </div>
  );
};
function Index() {
  return (
    <>
      <Seo />
      <div className="w-full hyphens-auto scroll-smooth transition-colors duration-500 ease-in-out">
        <section className="sm:rounded-b-30 sm:overflow-hidden h-screen w-full select-none">
          <div className="w-full h-screen relative overflow-hidden">
            <img
              src={brightonio}
              alt=""
              className="object-cover object-center h-full sm:w-4/5 mx-auto"
            />
            <img
              src={hand}
              alt=""
              className="absolute top-0 animate-rotate-5 left-[2%] sm:left-[10.5%] sm:-translate-x-1/2 object-cover object-center h-screen sm:w-4/5 "
            />
            <span className="absolute z-10 top-2/3 left-1/2 -translate-x-1/2 -translate-y-1/2 text-8xl sm:text-[200px] sm:font-bold font-Bebas text-blue-3 sm:left-1/2 sm:-translate-x-1/2">
              Brighton
            </span>
            <p className="absolute z-10 bottom-1/4 translate-y-1/2 sm:top-3/4 sm:bottom-auto left-1/2 sm:translate-y-1/2 -translate-x-1/2 w-max  text-lg sm:text-2xl text-gray-50 bg-blue-3 px-4 py-1 -skew-x-6 -rotate-2">
              The bridge to your future{" "}
            </p>
          </div>
        </section>
        <section className="">
          <div className="flex flex-col-reverse xl:flex-row items-center gap-10 lg:m-20 xl:m-40">
            <div className="flex flex-col xl:w-1/2 gap-5">
              <h1 className="text-4xl tracking-wide sm:text-7xl 2xl:text-8xl text-blue-4 font-Bebas font-bold text-center xl:text-right">
                Bienvenido a Brighton Centro de Inglés
              </h1>
              <p className="text-xl xl:text-2xl hyphens-none text-center xl:text-right ">
                Brighton es un centro de inglés ubicado en la ciudad de Pasto
                con más de 11 años de experiencia preparando a estudiantes y
                profesionales en ampliar sus conocimientos para alcanzar sus
                sueños con el idioma inglés. Contamos con profesores altamente
                calificados; y con una metodología dinámica y personalizada.
              </p>
            </div>
            <div className="h-[225px] xl:w-1/2 sm:h-full rounded-lg rounded-tl-none overflow-hidden shadow-[-10px_10px_0px_0px_#0d2334]">
              <img
                src={"https://brightonenglishcenter.edu.co/img/brighton_1.jpg"}
                alt="Brighton es un Centro de Inglés ubicado en la ciudad de Pasto con más de 11 años de experiencia preparando a estudiantes y profesionales en ampliar sus conocimientos para alcanzar sus sueños con el idioma inglés"
                width={1080}
                loading="lazy"
                className="w-full h-full object-cover object-top hover:motion-safe:scale-110 transition duration-300 ease-in-out "
              />
            </div>
          </div>
        </section>
        <section className="">
          <div className="my-20 mx-0 xl:m-40 space-y-10">
            <div className="text-center">
              <h2 className="text-7xl sm:text-6xl 2xl:text-7xl text-blue-4 font-bold font-Bebas">
                Aprende inglés en Brighton
              </h2>
            </div>

            {/* CARRUSELES DE PRUEBA ---------------- */}
            <Carrusel items={itemsCarrusel} />
          </div>
        </section>
        <section className=" rounded-t-30 bg-primario">
          <div className="">
            <div className=" text-center leading-relaxed p-20 xl:p-40 space-y-10">
              <h2 className="text-4xl sm:text-6xl 2xl:text-7xl text-secundario tracking-wide font-bold font-Bebas">
                Prepárate para el éxito global
              </h2>
              <p className=" text-white sm:w-2/3 mx-auto text-xl xl:text-2xl">
                Nuestros programas de entrenamiento están diseñados para
                brindarte las habilidades y el conocimiento necesario para
                enfrentarte con confianza a los exámenes internacionales más
                reconocidos.
              </p>
            </div>
            <div className="flex w-full h-[450px] 2xl:h-[600px] gap-2">
              {Exams.map((value, index) => (
                <ExamnCard
                  key={index}
                  exam={value.name}
                  img={value.img}
                  link={value.link}
                />
              ))}
            </div>
          </div>
        </section>
        <section className="bg-primario  bg-center  bg-fixed flex flex-col gap-10 rounded-b-30 relative z-10">
          <div className="m-20 xl:m-40 space-y-10 bgyell">
            <h2 className="text-4xl sm:text-6xl 2xl:text-7xl text-secundario font-bold font-Bebas text-center xl:w-3/4 mx-auto tracking-wider">
              Descubre por qué Brighton es tu mejor opción para aprender
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 xl:w-3/4 mx-auto">
              <div className="grid gap-5">
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Certificaciones Internacionales"
                  descripcion="En Brighton, ofrecemos preparación especializada para
                      certificaciones internacionales como el IELTS, TOEFL,
                      examenes Cambridg; para certificaciones nacionales como APTIS y OOPT. Estas certificaciones te abrirán puertas en
                      universidades, empresas y oportunidades globales. "
                  boton="Conoce más"
                  icono="fa-trophy"
                />
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Profesores Certificados Internacionalmente"
                  descripcion="Nuestros profesores están altamente capacitados y con experiencia en contextos globales. Su enfoque se centra en desarrollar tus habilidades y confianza en el idioma."
                  icono="fa-person-chalkboard"
                />
              </div>
              <div className="grid gap-5">
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Clases Online"
                  descripcion="Participa de nuestras clases en línea desde la comodidad de tu hogar o donde te encuentres y disfruta de una experiencia dinámica y eficaz."
                  icono="fa-wifi"
                />
                <WhyCard
                  colorPrimario="#fffbeb"
                  titulo="Metodología Basada en Contextos Reales"
                  descripcion="Nuestra metodología innovadora está diseñada para que aprendas inglés en contextos reales, te sumergimos en situaciones auténticas para que no solo aprendas, sino que te sientas preparado para comunicarte eficazmente en inglés en cualquier entorno."
                  icono="fa-earth-americas"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="">
          <div className="my-20 mx-0 xl:m-40 space-y-10">
            <h2 className="text-4xl sm:text-6xl 2xl:text-7xl text-center hyphens-none font-bold text-blue-4 font-Bebas">
              Conoce a nuestros docentes que estarán presentes en tu formación
            </h2>
            <Carrusel items={itemsProfes} />
          </div>
        </section>
        <section className="h-screen sm:h-[50vh] xl:[60vh] bg-blue-4 relative my-10">
          <img
            src={seccion}
            alt="Cursos de ingles"
            className="absolute w-full object-cover h-1/2 sm:w-2/3  sm:h-max bottom-0 sm:left-0 2xl:left-0 "
          />
          <div className="p-5 text-center sm:text-left absolute sm:right-5 sm:bottom-1/2 sm:translate-y-1/2 sm:w-max  flex flex-col gap-5 justify-around">
            <p className="font-grand text-5xl 2xl:text-6xl text-yellow-2">
              No pierdas esta oportunidad
            </p>
            <h2 className="text-3xl 2xl:text-4xl text-white font-bold">
              Certifica tu inglés en Brighton
            </h2>
            <a
              href="https://wa.link/54lqy2"
              target="_blank"
              rel="noreferrer"
              className="self-center sm:self-end text-2xl font-bold px-5 py-2 2xl:px-6 2xl:py-3 2xl:text-3xl bg-yellow-2 w-max rounded-full rounded-tl-none  text-primario hover:bg-secundario duration-300 "
            >
              Regístrate
            </a>
          </div>
        </section>

        <section className="">
          <div className="m-20 xl:m-40 space-y-10">
            <h2 className="text-4xl lg:text-6xl 2xl:text-7xl tracking-wide text-center w-full font-bold text-blue-4 font-Bebas">
              Brighton es la elección número uno para desarollar tu inglés
            </h2>
            <CardEstadisticas data={dataEstadisticas} />
          </div>
        </section>
        <section>
          <TestimonialsMarquee />
        </section>
      </div>
    </>
  );
}

export default Index;
